import styled from 'styled-components'
import { BodyCopy } from '../Globals'

export const StyledDiv = styled(BodyCopy)`
  margin: 0 10px 0 0;
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
`

export const FootnoteContainer = styled.div`
  display: flex;
  margin: 20px 0 0;
`
